import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { connect, useDispatch } from 'react-redux'
import { Row, Col } from 'antd'
import RootState from 'typings/RootState'
import { DropdownList, DropdownPopupMenu } from 'Components/Shared/Form'
import { CloseIcon, LoadingIcon } from 'Components/Shared/Icon'
import PrimaryButton from 'Components/Shared/Button/PrimaryButton'
import { InputSearch, InputText } from 'Components/Shared/Input'
import { DataItem } from 'features/admin/qcType/types'
import { ProjectListItem } from 'features/project/project.types'
import { selectDataList } from 'features/admin/project/selector'
import { CompanyVandorItem, GetFilterListReq } from 'features/admin/user/types'
import { getCompanyVandorList } from 'features/admin/user/api'
import {
  selectCompanyVandorList,
  selectVendorEvent,
} from 'features/admin/user/selector'

type Props = ReduxProps &
  DispatchProps & {
    UserEmail: string
    userList: any
    item: any
    onSave?: (item: any) => void
    onClose: () => void
    token: string
  }

const SettingVendorERCDetail: React.ComponentType<Props> = props => {
  const { UserEmail, item, userList, token, event } = props
  const [dataItem, setdataItem] = useState({} as any)
  const [query, setQuery] = useState('')
  const [searchText, setSearchText] = useState('')

  const dispatch = useDispatch()

  useEffect(() => {
    if (query.length >= 2) {
      onFindVendorList()
    }
  }, [searchText])

  useEffect(() => {
    const timeOutId = setTimeout(() => setSearchText(query), 1000)
    return () => clearTimeout(timeOutId)
  }, [query])

  const onFindVendorList = () => {
    const req: GetFilterListReq = {
      UserEmail,
      TextFilter: searchText,
    }
    dispatch(getCompanyVandorList(token, req))
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onFindVendorList()
    }
  }

  const renderUserDataFormat = (item: CompanyVandorItem) => {
    let content = `${item.VendorCode} - ${item.VendorName}`
    return content
  }

  const renderSearchContent = (data: CompanyVandorItem[]) => {
    const loading = (
      <ContentBody>
        <LoadingIcon />
      </ContentBody>
    )
    const empty = (
      <ContentBody>
        <Txt>ไม่มีข้อมูล</Txt>
      </ContentBody>
    )

    const emptySearch = (
      <ContentBody>
        <Txt>ระบุคำที่ต้องการค้นหา อย่างน้อย 2 ตัวอักษร</Txt>
      </ContentBody>
    )

    const content =
      data && data.length > 0 ? (
        <SearchContentArea>
          {data.map((item, index) => {
            const data = renderUserDataFormat(item)
            return (
              <SearchItem
                key={index}
                onClick={() => {
                  setQuery(item.VendorName)
                  setdataItem(item)
                  // onSave(item)
                }}
              >
                {data}
              </SearchItem>
            )
          })}
        </SearchContentArea>
      ) : query.length < 2 ? (
        emptySearch
      ) : (
        empty
      )

    return event.IsLoading ? loading : content
  }

  const onSave = () => {
    if (props.onSave) {
      props.onSave(dataItem)
      setQuery('')
      setSearchText('')
    }
  }
  return (
    <MainPage>
      <Header>
        <CloseIcon color="#8b99a7" size={24} onClick={props.onClose} />
      </Header>
      <Row>
        <Col span={24}>
          <Title>เพิ่มผู้รับเหมา</Title>
        </Col>
        <Col span={24}>
          <BodyArea>
            <InputSearch
              placeholder={'ค้นหา Vendor ด้วยชื่อ หรือ Code'}
              value={query}
              onChange={(val: string) => setQuery(val)}
              showSuggess={true}
              searchContent={renderSearchContent(userList)}
              onKeyDown={handleKeyDown}
            />
          </BodyArea>
        </Col>
      </Row>
      <Row type="flex" justify="end">
        <SaveArea>
          <PrimaryButton onClick={onSave} text="บันทึก" />
        </SaveArea>
      </Row>
    </MainPage>
  )
}

const MainPage = styled.div`
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  overflow-x: scroll;
`
const Txt = styled.div`
  font-size: 20px;
  font-family: 'DB Helvethaica X 55 Regular';
`
const Header = styled.div`
  text-align: right;
  height: 40px;

  svg {
    cursor: pointer;
  }
`

const Title = styled.div`
  color: black;
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 28px;
  margin-bottom: 14px;
`
const SearchArea = styled.div`
  margin-top: 22px;
`
const Text = styled.div`
  color: black;
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 20px;
`

const SaveArea = styled.div`
  margin-top: 32px;
  float: right;
  width: 160px;
`

const BodyArea = styled.div`
  font-family: 'DB Helvethaica X 55 Regular';
  span {
    font-size: 20px;
  }
  .ant-dropdown-trigger {
    margin-bottom: 12px;
  }
  .input-title {
    margin-bottom: 12px;
  }
`

const SearchContentArea = styled.div`
  max-height: 192px;
  overflow: scroll;
`

const SearchItem = styled.div`
  padding: 8px 24px;
  font-size: 20px;
  font-family: 'DB Helvethaica X 55 Regular';
  &:hover {
    background-color: #e6f7ff;
    cursor: pointer;
  }
`

const ContentBody = styled.div`
  width: 100%;
  text-align: center;
  padding: 70px 0;
  height: 192px;
`

const mapStateToProps = (state: RootState) => {
  return {
    userList: selectCompanyVandorList(state),
    event: selectVendorEvent(state),

    // projectList: selectDataList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingVendorERCDetail)
